const styles ={
    picker:{
        width: '100%',          //over-rule parent styles
        marginTop: '2rem'
    },
    addColor: {
        width: '100%',
        padding: '1rem',
        marginTop: '1rem',
        fontSize: '2rem'
    },
    input:{
        width: '100%',
        height: '70px'
    }
}

export default styles;